import { render, staticRenderFns } from "./pane-project.vue?vue&type=template&id=88896e1e&"
import script from "./pane-project.vue?vue&type=script&lang=js&"
export * from "./pane-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports